module.exports = __webpack_public_path__ + "static/media/poorwill16.828f70fa.JPG";